var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"signal-source-item",class:[
     `signal-source-item--${_vm.size}`,
     {
      'signal-source-item_active':_vm.opt.getActive(),
      'is-disabled': _vm.opt.disable
      }
     ],on:{"click":_vm.activeClick}},[_c('div',{class:[`signal-source-item--${_vm.size}-left`]},[_c('i',{staticClass:"iconfont",class:_vm.opt.img})]),_c('div',{class:[`signal-source-item--${_vm.size}-right`]},[_c('div',{class:[`signal-source-item--${_vm.size}-right-name`]},[_vm._v(" "+_vm._s(_vm.opt.name)+" ")]),(_vm.opt.desc)?_c('div',{class:[`signal-source-item--${_vm.size}-right-desc`]},[_vm._v(" "+_vm._s(_vm.opt.desc)+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }